module.exports = __webpack_public_path__ + "img/40_69_010_900.1ec3e238.jpg";